import React from 'react'
import VehicleBin from './Bins/VehicleBin'
import EnvironmentBin from './Bins/EnvironmentBin'
import usePath from 'hooks/usePath'
import VehicleTypes from './Bins/VehicleType'
import HexColorsBin from './Bins/HexColorsBin'
import Defaults from './Bins/Defaults'
import styles from './contentBin.module.scss'
import Materials from './Bins/Materials'
import MaterialTypes from './Bins/MaterialTypes'

const ContentBrowse = () => {
  const path = usePath()
  switch (path[1]) {
    case 'vehicle': {
      return <VehicleBin />
    }
    case 'environment': {
      return <EnvironmentBin />
    }
    case 'vehicleTypes': {
      return <VehicleTypes />
    }
    case 'hexColors': {
      return <HexColorsBin />
    }
    case 'materials': {
      return <Materials />
    }
    case 'materialTypes': {
      return <MaterialTypes />
    }
    case 'defaults': {
      return <Defaults />
    }
    default: {
      return 'default'
    }
  }
}

const ContentBin = props => {
  return (
    <div className={styles.contentBin}>
      <ContentBrowse />
    </div>
  )
}

export default ContentBin
